import React from "react";
import AutoFocusedInput from "./AutoFocusedInput";
import styled from "styled-components";
import PropTypes from "prop-types";
import { UncontrolledTooltip } from 'reactstrap';

const CellContainer = styled.div`
  display: flex;
  flex: 1 0 100%;
  align-items: center;
  height: 100%;
  overflow: hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
  margin: 0px -5px;
`;

class EditableInputCell extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
    };
    this._inputRef = React.createRef();
    this._spanRef = React.createRef();
    this.handleClick = this.handleClick.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  handleClick() {
    this.setState({
      editing: true
    })

  }

  UNSAFE_componentWillUnmount() {
    if (this.state.editing) {
      console.log("Component with state is going to be discarded");
      if (this._inputRef.current) {
        var value = this._inputRef.current.getValue();
        this.fireValueChange(value);
      }
    }

  }

  handleBlur(e) {
    this.fireValueChange(e.target.value);
    this.setState({editing:false});
  }

  fireValueChange(value) {
    let oldValue = this.props.cellData;

    if (oldValue === value) {
      return;
    }

    this.props.column.onValueChange({
      rowData: this.props.rowData,
      rowIndex: this.props.rowIndex,
      column: this.props.column,
      value: value
    });
    // this.props.container.props.stopEditing(this.props.rowIndex, this.props.columnIndex);

  }

  render() {
    const { column, cellData, rowIndex, columnIndex, rowData } = this.props
    //const { editing } = this.state
    let inputField;
    let editing = this.state.editing;//this.props.container.props.isEditing(rowIndex, columnIndex);
    if (editing) {

      inputField = <AutoFocusedInput type="text" defaultValue={cellData} onBlur={this.handleBlur} ref={this._inputRef}
                                     className={column.format || ""}/>
    } else if (column.type !== "number" || !cellData || !isNaN(cellData)){
      inputField = cellData;
    } else {
      inputField = "#ERROR";
    }

    let id = ""+rowIndex+":"+columnIndex;
    let tooltip = null;
    if (column.tooltipGetter){
      const tooltipText = column.tooltipGetter({ column, cellData, rowIndex, columnIndex, rowData, editing });
      if (tooltipText){
        console.log(`Editing: ${editing}`)
        inputField = (<span ref={this._spanRef}>{inputField}</span>)
        tooltip=(<UncontrolledTooltip placement="top" target={this._spanRef}>{tooltipText}</UncontrolledTooltip>)
      }
    }
    return (
      <CellContainer onClick={this.handleClick}
                     className={(editing?"EditableTableCellWithInput":"EditableTableCell") +" " + (column.format || "")}
                     id={id}
                     //key={""+rowIndex+":"+columnIndex}
      >
        { inputField }
        { tooltip }
      </CellContainer>

    );
  }


}

EditableInputCell.propTypes = {
  column: PropTypes.object.isRequired,
  container: PropTypes.any.isRequired,
  rowIndex: PropTypes.number.isRequired,
  rowData: PropTypes.object.isRequired,
  columnIndex: PropTypes.number.isRequired,
  // editing: PropTypes.bool.isRequired,
  cellData: PropTypes.any
};


export default EditableInputCell;